import { render, staticRenderFns } from "./invitationPoster.vue?vue&type=template&id=026178c4&scoped=true"
import script from "./invitationPoster.vue?vue&type=script&lang=js"
export * from "./invitationPoster.vue?vue&type=script&lang=js"
import style0 from "./invitationPoster.vue?vue&type=style&index=0&id=026178c4&prod&lang=less&scoped=true"
import style1 from "./invitationPoster.vue?vue&type=style&index=1&id=026178c4&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "026178c4",
  null
  
)

export default component.exports